module.exports = __webpack_public_path__ + "static/7-217c0ef9bb62a827b40eb4569e87dacc.jpg";